<div class="questions-tab-content">
  <div class="table header">
    <mat-toolbar class="header-base" color="primary">
      <button mat-mini-fab color="white" (click)="addQuestion()">
        <mat-icon>add</mat-icon>
      </button>
    </mat-toolbar>
  </div>

  <div class="grid-container">
    <ng-container *ngFor="let quest of questions; let indexOfelement = index">
      <div class="grid-item">
        <mat-card style="text-align: center">
          <button mat-icon-button matTooltip="Delete" class="delete-button" (click)="remove(indexOfelement)">
            <mat-icon color="warn">delete</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Copy image name" class="copy-button" (click)="copyImageName(indexOfelement)">
						<mat-icon color="primary">collections</mat-icon>
					</button>
          <div class="image-container" (click)="editImage(indexOfelement, quest)">
            <img mat-card-image [src]="createImage(quest.imageId)" style="width: 100%;">
            <div class="image-text" style="text-align: center;">Change Image</div>
            <div class="background"></div>
          </div>
          <mat-card-content style="text-align: center">
            <ng-container class="lesson-name-content">
              <mat-form-field appearance="outline">
                <mat-label>Question</mat-label>
                <input matInput [(ngModel)]="quest.question" />
                <button *ngIf="quest.question" matSuffix mat-icon-button aria-label="Clear"
                  (click)="quest.question = ''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Keywords</mat-label>
                <input matInput [(ngModel)]="quest.keywords" (ngModelChange)="changeKeys($event, quest)" />
                <button *ngIf="quest.keywords" matSuffix mat-icon-button aria-label="Clear"
                  (click)="quest.keywords = []">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Difficulty</mat-label>
                <mat-select [(ngModel)]="quest.difficulty">
                  <ng-container *ngFor="let difficulty of difficulties">
                    <mat-option [value]="difficulty">{{difficulty}}</mat-option>
                  </ng-container>
                </mat-select>
                <button *ngIf="quest.difficulty" matSuffix mat-icon-button aria-label="Clear"
                  (click)="quest.difficulty = 1">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Min. Words</mat-label>
                <input matInput type="number" [(ngModel)]="quest.minWords" />
                <button *ngIf="quest.minWords" matSuffix mat-icon-button aria-label="Clear"
                  (click)="quest.minWords = 0">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </ng-container>
          </mat-card-content>
        </mat-card>
      </div>
    </ng-container>
  </div>
</div>